import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Alert,
} from "@mui/material";

type Props = {
  open: boolean;
  onClose: () => void;
  initial?: {
    message?: string | null;
    backgroundColor?: string | null;
    textColor?: string | null;
  };
  onSave: (values: {
    message: string;
    backgroundColor: string;
    textColor: string;
  }) => Promise<void> | void;
  saving?: boolean;
  serverError?: string | null;
};

export default function AnnouncementBannerFormDialog({
  open,
  onClose,
  initial,
  onSave,
  saving,
  serverError,
}: Props) {
  const [message, setMessage] = React.useState("");
  const [backgroundColor, setBackgroundColor] = React.useState("#000000");
  const [textColor, setTextColor] = React.useState("#ffffff");

  React.useEffect(() => {
    if (!open) return;

    setMessage(initial?.message ?? "");
    setBackgroundColor(initial?.backgroundColor ?? "#000000");
    setTextColor(initial?.textColor ?? "#ffffff");
  }, [open, initial]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Update Announcement Banner</DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <Stack spacing={2}>
          {serverError ? <Alert severity="error">{serverError}</Alert> : null}

          <TextField
            label="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            multiline
            minRows={3}
            placeholder="e.g. 30 Days Free Returns | Free Shipping Lahore wide | Lifetime Warranty"
            fullWidth
          />
          {/* 
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <TextField
              label="Background Color"
              value={backgroundColor}
              onChange={(e) => setBackgroundColor(e.target.value)}
              fullWidth
              placeholder="#000000"
            />
            <TextField
              label="Text Color"
              value={textColor}
              onChange={(e) => setTextColor(e.target.value)}
              fullWidth
              placeholder="#ffffff"
            />
          </Stack> */}

          {/* Preview */}
          <div
            style={{
              padding: "10px 12px",
              background: backgroundColor || "#000",
              color: textColor || "#fff",
              textAlign: "center",
              fontSize: 13,
              letterSpacing: 0.2,
              borderRadius: 6,
            }}
          >
            {message
              ? message || "Preview message..."
              : "Message will appear here"}
          </div>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={!!saving}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() =>
            onSave({
              message,
              backgroundColor,
              textColor,
            })
          }
          disabled={!!saving}
        >
          {saving ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
